export function ajaxFilter() {
    const $body = $("body");
    const filterHolder = $(".ajax-filter");
    const filterTitle = $(".ajax-filter .title");
    const filterReset = $(".ajax-filter input[type=\"reset\"]");

    filterHolder.on("change", "input[type=\"radio\"]", function () {
        if ($(this).val() === "") {
            let titleText = $(this).parents(".form-group").find(".title").data("text");
            $(this).parents(".form-group").find(".title").text(titleText);
        } else {
            let valueItem = $(this).next("label").text().replace(",", "");
            $(this).parents(".form-group").find(".title").text(valueItem);
        }

        if (window.innerWidth < 1200 || $body.hasClass("touch")) {
            $(this).parents(".form-group").find(".radio-wrap").slideUp(300)
        }
    });

    filterTitle.on("click", function () {
        if (window.innerWidth < 1200 || $body.hasClass("touch")) {
            if (!$(this).hasClass("active")) {
                $(".radio-wrap").slideUp(300);
                filterTitle.removeClass("active");
                $(this).addClass("active").next(".radio-wrap").slideDown(300);
            } else {
                $(this).removeClass("active").next(".radio-wrap").slideUp(300);
            }
        }
    });

    filterReset.on("click", function () {
        $(this).removeClass("active");

        $('.radio-wrap input[type="radio"]').each(function () {
            $(this).prop("checked", false);
            $(this).removeAttr('checked');
        });

        $('.radio-wrap').find('.wrap:first-child input[type="radio"]').prop('checked', true); //attr("checked", "checked");
        $('.radio-wrap').find('.wrap:first-child input[type="radio"]').attr('checked', 'checked');

        $('.radio-wrap').find('.wrap:first-child input[type="radio"]').addClass('dddd');

        if ($('input[name="location"]').length) {
            var title_location = $('input[name="location"]').parents('.form-group').find('.title').attr('data-text');
            $('input[name="location"]').parents('.form-group').find('.title').text(title_location);
        }

        if ($('input[name="type"]').length) {
            var title_type = $('input[name="type"]').parents('.form-group').find('.title').attr('data-text');
            $('input[name="type"]').parents('.form-group').find('.title').text(title_type);
        }

        var data = $('#portfolio-filter').serialize();

        $.ajax({
            url: ajaxvars.ajaxurl,
            data: {
                action: 'load_portfolio',
                data: data,
                paged: 0
            },
            type: 'POST',
            success: function success(response) {
                if (response) {
                    $('.portfolio-holder .cascade').html(response.content);
                    $('.portfolio-holder .load-more').html(response.page);
                }
            }
        });
    });

    //AJAX
    $('#portfolio-filter').change(function (event) {
        var btnClick = event.target;
        var titleText = '';

        console.log(event);

        if (btnClick.name == 'location') {

            $('.radio-wrap input[name="type"]').each(function () {
                //$(this).prop('checked', false);
            });
            $('.radio-wrap .wrap:first-child input[name="type"]').prop('checked', true);
            titleText = $("input[name=\"type\"]").parents(".form-group").find(".title").data("text");
            $("input[name=\"type\"]").parents(".form-group").find(".title").text(titleText);


            $('.radio-wrap input[name="brand"]').each(function () {
                //$(this).prop('checked', false);
            });
            $('.radio-wrap .wrap:first-child input[name="brand"]').prop('checked', true);
            titleText = $("input[name=\"brand\"]").parents(".form-group").find(".title").data("text");
            $("input[name=\"brand\"]").parents(".form-group").find(".title").text(titleText);
        }

        if (btnClick.name == 'type') {
            $('.radio-wrap input[name="location"]').each(function () {
                //$(this).prop('checked', false);
            });
            $('.radio-wrap .wrap:first-child input[name="location"]').prop('checked', true);
            titleText = $("input[name=\"location\"]").parents(".form-group").find(".title").data("text");
            $("input[name=\"location\"]").parents(".form-group").find(".title").text(titleText);

            $('.radio-wrap input[name="brand"]').each(function () {
               // $(this).prop('checked', false);
            });
            $('.radio-wrap .wrap:first-child input[name="brand"]').prop('checked', true);
            titleText = $("input[name=\"brand\"]").parents(".form-group").find(".title").data("text");
            $("input[name=\"brand\"]").parents(".form-group").find(".title").text(titleText);
        }

        if (btnClick.name == 'brand') {
            $('.radio-wrap input[name="type"]').each(function () {
                //$(this).prop('checked', false);
            });
            $('.radio-wrap .wrap:first-child input[name="type"]').prop('checked', true);
            titleText = $("input[name=\"type\"]").parents(".form-group").find(".title").data("text");
            $("input[name=\"type\"]").parents(".form-group").find(".title").text(titleText);

            $('.radio-wrap input[name="location"]').each(function () {
                //$(this).prop('checked', false);
            });
            $('.radio-wrap .wrap:first-child input[name="location"]').prop('checked', true);
            titleText = $('input[name="location"]').parents(".form-group").find(".title").data("text");
            $("input[name=\"location\"]").parents(".form-group").find(".title").text(titleText);

        }

        var data = $(this).serialize();

        $.ajax({
            url: ajaxvars.ajaxurl,
            data: {
                action: 'load_portfolio',
                data: data,
                paged: 0
            },
            type: 'POST',
            success: function success(response) {
                if (response) {
                    $('.portfolio-holder .cascade').html(response.content);
                    $('.portfolio-holder .load-more').html(response.page);

                    if ($('.radio-wrap .wrap:first-child input[type=radio]:checked').length !== 0) {
                        filterReset.addClass('active');
                    } else {
                        filterReset.removeClass('active');
                    }
                }
            }
        });
    });

    $('.load-more').on('click', '.light-btn', function () {
        var data = $('#portfolio-filter').serialize();
        var paged = $(this).attr('data-paged');

        $.ajax({
            url: ajaxvars.ajaxurl,
            data: {
                action: 'load_portfolio',
                data: data,
                paged: paged
            },
            type: 'POST',
            success: function success(response) {
                if (response) {
                    $('.portfolio-holder .load-portfolio:last-child').after(response.content);
                    $('.portfolio-holder .load-more').html(response.page);
                }
            }
        });
    });

    window.addEventListener("load", function () {
        var item_text;
        var item_name;
        $('.radio-wrap input[type="radio"]:checked').each(function () {
            if ($(this).val() !== "") {
                item_text = $(this).next("label").text().replace(",", "");
                item_name = $(this)[0].name;
            }
        });
        $('input[name="' + item_name + '"]').parents('.form-group').find('.title').text(item_text);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ajax-filter.js